import gcDown from './gc-down.vue'
import gcGuide from './gc-guide.vue'
import gcHeader from './gc-header.vue'
import gcHeaderRank from './gc-header-rank.vue'
import gcMidde from './gc-midde.vue'
import gcSkeleton from './gc-skeleton.vue'
import publicFoot from '../components/cookList/publicFoot'
import publicHead from '../components/cookList/publicHead'
export default { gcDown, gcGuide, gcHeader, gcMidde, gcSkeleton, gcHeaderRank, publicHead, publicFoot }
